import React from "react";

import * as S from "./styles";

interface PlayButtonProps {
  action: Function;
  playing?: boolean;
}

export const PlayButton: React.FC<PlayButtonProps> = ({
  action,
  playing = false,
}) => {
  return (
    <S.Button onClick={() => action()} playing={playing}>
      {playing ? <S.Pause /> : <S.Play />}
    </S.Button>
  );
};
